"use client";

import { Toaster as Sonner, ToasterProps as SonnerToasterProps } from "sonner";

interface ToasterProps extends SonnerToasterProps {
  theme?: "light" | "dark" | "system";
}

const Toaster = ({ theme = "system", ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      richColors={true}
      closeButton={true}
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "!bg-white !text-slate-900 !border-gray-200 !shadow-xl !backdrop-blur-sm dark:!bg-slate-800 dark:!text-slate-100 dark:!border-slate-700 radius-lg",
          title: "!text-slate-900 dark:!text-slate-100 !font-medium !text-sm",
          description:
            "!text-slate-700 dark:!text-slate-300 !text-sm !opacity-90 !mt-1",
          actionButton:
            "!bg-orange-600 !text-white hover:!bg-orange-700 !border-orange-600 radius-default !px-3 !py-1.5 !text-xs !font-medium !ml-auto",
          cancelButton:
            "!bg-slate-100 !text-slate-900 hover:!bg-slate-200 dark:!bg-slate-700 dark:!text-slate-100 dark:hover:!bg-slate-600 radius-default !px-3 !py-1.5 !text-xs !font-medium",
          closeButton:
            "!bg-slate-100 !text-slate-900 hover:!bg-slate-200 dark:!bg-slate-700 dark:!text-slate-100 dark:hover:!bg-slate-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
